import { gql } from "@apollo/client";

export const GET_SUPPORT = gql`
query GetSupport($page: Int, $limit: Int, $filter: String, $sort: userSort, $search: String, $from: String, $to: String, $status: Boolean) {
  getSupport(page: $page, limit: $limit, filter: $filter, sort: $sort, search: $search, from: $from, to: $to,status: $status) {
    count
    data {
      id
      name
      mobile
      awbNo
      orderID
     message {
        sender
        message
        createdAt
        attachments
      }
      createdAt
      isActive
        order {
        id
        customerId
        order_number
        pickupAddress {
          name
          phone
          address1
          city
          stateId {
            id
            name
          }
          zipCode
          customerId
        }
        deliveryAddress {
          name
          phone
          address1
          city
          zipCode
          customerId
        }
        stateId
        trackStatus
        order_amount
        package_weight
        isDeleted
        isActive
        status
        courier_name
        paymentDetails
        order_id
        warehouse_name
        awb_number
        ProductPrice
        ProductName
        createdAt
        paymentStatus
        package_weight_Length
      }
    }
  }
}
`

export const UPDATE_SUPPORT = gql`

mutation Mutation($updateSupportId: String, $isActive: Boolean) {
  updateSupport(id: $updateSupportId, isActive: $isActive)
}
`
export const GET_CUSTOMER_TICKET = gql`
query GetSupportForCustomer($status: Boolean, $to: String, $ticketstatus:String, $from: String, $search: String, $sort: userSort, $page: Int, $limit: Int, $filter: String) {
  getSupportForCustomer(status: $status, to: $to, ticketstatus:$ticketstatus,from: $from, search: $search, sort: $sort, page: $page, limit: $limit, filter: $filter) {
    count
    data {
      id
      name
      mobile
      awbNo
      orderID
      message {
        sender
        message
        createdAt
        attachments
      }
      createdAt
      order {
        status
        awb_number
      }
      issue_type
      ticketID
      issue_category
      status
      ticket_type_issue
    }
  }
} 
`

export const CREATE_TICKET_REMARK = gql`
  mutation AddMessageToSupport($ticketId: String!, $messageInput: MessageInput) {
  addMessageToSupport(ticketId: $ticketId, messageInput: $messageInput) {
    status
    message
}
}
`
export const GET_MESSAGE = gql`
query GetMessagesByTicketId($ticketId: String!) {
  getMessagesByTicketId(ticketID: $ticketId) {
    id
    name
    mobile
    awbNo
    orderID
    message {
      sender
      message
      createdAt
      attachments
    }
    createdAt
    isActive
    order {
      order_number
      awb_number
      ProductPrice
      ProductName  
    }
    issue_type
    ticketID
    issue_category
    status
    ticket_type_issue
  }
}
`